import React from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Footor from './components/Footorall'
import Contact from "./pages/contact/Contact";
import Gallry from "./pages/gallary/Gallry";
import Trainer from "./pages/trainers/Trainer";
import Plan from "./pages/plans/Plan";
import Notfound from "./pages/notfound/Notfound.jsx";

const App = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route index element={<Home />} />

        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
       <Route path="gallery" element={<Gallry />} />
        <Route path="plans" element={<Plan />} />
        <Route path="trainers" element={<Trainer />} />
        <Route path="*" element={<Notfound />} />  
      </Routes> 
      <Footor/>
    </BrowserRouter>
  );
};

export default App;
